import React from "react";

//Assets
import Quotes from "../../Assets/quotes.svg";
import Mark1 from "../../Assets/mark1.svg";
import youtube from "../../Assets/youtubelogo.svg";
import inlogo from "../../Assets/in.svg";
import insta from "../../Assets/insta.svg";
import fb from "../../Assets/fb.svg";
import line from "../../Assets/lines.svg";

function ProductInfo() {
  return (
    <div className="productsSection_info">
      <div className="productsSection_info_title">
        <img src={Quotes} alt="Quotes" />
        <div>Make something Unreal</div>
        <img src={Quotes} alt="Quotes" />
      </div>
      <div className="productsSection_info_description">
        Mark 1 is a complete suite of development tools for anyone working with real-time technology. It gives creators across industries the freedom and control to deliver cutting-edge entertainment,
        compelling visualizations, and immersive virtual worlds.
      </div>
      <div className="productsSection_info_logo">
        <img src={Mark1} alt="mark1-logo" />
        <div>Mark-1</div>
      </div>

      <div className="socialinks">
        <div>
          <img src={youtube} alt="3D Model" />
        </div>
        <div>
          <img src={fb} alt="3D Model" />
        </div>
        <div>
          <img src={insta} alt="3D Model" />
        </div>
        <div>
          <img src={inlogo} alt="3D Model" />
        </div>
      </div>

      <div className="line">
        <img src={line} alt="3D Model" />
      </div>
    </div>
  );
}

export default ProductInfo;
